export function ShowTaskpane(event: Office.AddinCommands.Event) {
    Office.addin.showAsTaskpane();
    event.completed();
}